import { render, staticRenderFns } from "./BlockDateCardDay.vue?vue&type=template&id=1a80c91a&"
import script from "./BlockDateCardDay.vue?vue&type=script&lang=js&"
export * from "./BlockDateCardDay.vue?vue&type=script&lang=js&"
import style0 from "./BlockDateCardDay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports